module.exports = __webpack_public_path__ + "img/github-image.192a6620.svg";